import Component from "./dashboard.component";
import { Config } from "./dashboard.config";
import { watchDashboard as saga } from "./redux/dashboard.sagas";
import { reducer } from "./redux/dashboard.reducer";

export default { Component, saga, reducer, config: Config };
